// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import appealCitizenEntity from './entities/appeal-citizen.json';
import appealCitizenMenu from '../pages/appeal-citizen/menu.json';
import appealCitizenFullForm from '../pages/appeal-citizen/forms/full.json';
import appealCitizenContextForm from '../pages/appeal-citizen/forms/context.json';
import appealCitizenMiniForm from '../pages/appeal-citizen/forms/mini.json';
import appealCitizenLookupForm from '../pages/appeal-citizen/forms/lookup.json';
import appealCitizenTableView from '../pages/appeal-citizen/views/table.json';
import appealCitizenCardsView from '../pages/appeal-citizen/views/cards.json';
import appealCitizenDashboardView from '../pages/appeal-citizen/views/dashboard.json';

/** Тип запису «Заявник» зі сторінками пакета: меню, форми та подання з pages/appeal-citizen/. */
export const appealCitizenDefinition: IRecordTypeDefinition = {
  ...appealCitizenEntity,
  views: assembleViewSet({
      table: appealCitizenTableView,
      cards: appealCitizenCardsView,
      dashboard: appealCitizenDashboardView,
  }),
  form: appealCitizenFullForm,
  forms: { full: appealCitizenFullForm, context: appealCitizenContextForm, mini: appealCitizenMiniForm, lookup: appealCitizenLookupForm },
  menu: appealCitizenMenu,
} as IRecordTypeDefinition;
